export const state = {
    marketTestList: [],
    currentMarketTest: {}
};